import $ from 'jquery';
import { getScrollTop } from '../utilities/get-scroll';
import passiveSupported from '../utilities/passive-event-supported';

var headerHeight = $('.c-header, .eb-js-header').outerHeight(true);
var headerBottomHeight = $('.c-header .c-header__bottom, .eb-js-header').outerHeight(true);
var headerOffset = headerHeight - headerBottomHeight;

const $headerBottom = $( '.c-header__bottom' );
let stickTrigger = $( window ).width() < 768 ? 0 : headerOffset;
let isSticky = false;

const stick = function() {
	if ( isSticky ) {
		return;
	}

	isSticky = true;
	$headerBottom.addClass( 'is-sticky' );
};

const unstick = function() {
	if ( ! isSticky ) {
		return;
	}

	isSticky = false;
	$headerBottom.removeClass( 'is-sticky' );
};

const handleScroll = function() {
	if ( getScrollTop() > stickTrigger ) {
		stick();
		$( '.eb-js-header' ).addClass( 'is-sticky' );
	} else {
		unstick();
		$( '.eb-js-header' ).removeClass( 'is-sticky' );
	}
};

let eventOptions = true;

if ( passiveSupported ) {
	eventOptions = {
		capture: true,
		passive: true,
	};
}

handleScroll();
window.addEventListener( 'scroll', handleScroll, eventOptions );

$( window ).on( 'resize deviceorientation', function() {
	stickTrigger = $( window ).width() < 768 ? 0 : 30;
	handleScroll();
} );

// Hide notification banner and set cookie
$('.c-notification__close').on('click', function (e) {
	e.preventDefault();
	$('.c-notification').remove();
	var postId = $(this).attr("data-post-id");
	if (postId == null) {
		var cookieName = 'notification_banner_closed';
	} else {
		var cookieName = 'notification_banner_' + postId + '_closed';;
	}
	Cookies.set(cookieName, '1', { expires: 30 });
});
